<template>
  <base-dialog @cancel="cancelDialog">
    <div slot="header">{{$t('system.text_152')}}</div>
    <div slot="body">
      <a-form-model
        ref="form"
        :model="form"
        :rules="rules"
        v-bind="formItemLayout">
        <a-form-model-item :label="$t('bill.rate.title.resource_type')" v-bind="formItemLayout" prop="resource_type">
          <a-select :placeholder="$t('bill.rate.title.resource_type')" v-model="form.resource_type">
            <a-select-option v-for="item in resourceTypeOptions" :key="item.value" :value="item.value">
              {{getBillResourceTypeLabel(item.value)}}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item :label="$t('bill.rate.title.usage_type')" v-bind="formItemLayout" prop="usage_type">
          <a-select :placeholder="$t('bill.rate.title.usage_type')" v-model="form.usage_type">
            <a-select-option v-for="item in usageTypeOptions" :key="item.value" :value="item.value">
              {{item.text}}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item :label="$t('bill.rate.title.brand')" v-bind="formItemLayout" prop="brand">
          <base-select
            v-model="form.brand"
            resource="bill_conditions"
            id-key="item_id"
            :params="brandParams"
            :label-format="getBrandName"
            :select-props="{placeholder: $t('bill.rate.title.brand'), allowClear: true}"
            :mapper="brandMapper" />
        </a-form-model-item>
        <a-form-model-item :label="$t('bill.rate.title.model')" v-bind="formItemLayout" prop="model">
          <a-input v-model="form.model" :plcaeholder="$t('bill.rate.title.model')" />
        </a-form-model-item>
        <a-form-model-item :label="$t('bill.rate.title.spec')" v-bind="formItemLayout" prop="spec">
          <spec-editor :form="form" :rules="rules" />
        </a-form-model-item>
        <a-form-model-item :label="$t('bill.no_bill')" :extra="$t('bill.no_bill_tip')" prop="no_bill">
          <a-switch v-model="form.no_bill" :checked-children="$t('bill.text_227')" :un-checked-children="$t('bill.text_228')" />
        </a-form-model-item>
      </a-form-model>
    </div>
    <div slot="footer">
      <a-button type="primary" @click="handleConfirm" :loading="loading">{{ $t('dialog.ok') }}</a-button>
      <a-button @click="cancelDialog">{{ $t('dialog.cancel') }}</a-button>
    </div>
  </base-dialog>
</template>

<script>
// import * as R from 'ramda'
import SpecEditor from '@Bill/sections/SpecEditor'
import DialogMixin from '@/mixins/dialog'
import WindowsMixin from '@/mixins/windows'
import { validateModelForm } from '@/utils/validate'
import { HYPERVISORS } from '@/constants'
import { arrayToObj } from '@/utils/utils'
import { getBillResourceTypeLabel } from '@Bill/utils'

export default {
  name: 'RateEditAttributesDialog',
  components: {
    SpecEditor,
  },
  mixins: [DialogMixin, WindowsMixin],
  data () {
    const initSpecValue = []
    const { spec = {}, resource_type = '', usage_type = '', brand = 'all', model = '', no_bill = false } = this.params.data[0]
    const keys = Object.keys(spec)
    keys.map(key => {
      initSpecValue.push({ key, value: spec[key] })
    })
    return {
      loading: false,
      form: {
        resource_type,
        usage_type,
        brand: brand,
        model,
        spec: initSpecValue,
        no_bill,
      },
      rules: {
        resource_type: { required: true, message: this.$t('common.tips.select', [this.$t('bill.rate.title.resource_type')]) },
        usage_type: { required: true, message: this.$t('common.tips.select', [this.$t('bill.rate.title.usage_type')]) },
        brand: { required: false, message: this.$t('common.tips.select', [this.$t('bill.rate.title.brand')]) },
        spec_key: { validator: this.specKeyValidator },
        spec_value: { required: true, message: this.$t('common.tips.input', [this.$t('bill.rate.spec_value')]) },
      },
      formItemLayout: {
        wrapperCol: {
          span: 20,
        },
        labelCol: {
          span: 4,
        },
      },
      resourceTypeOptions: [
        { text: this.$t('rate_resource_type.server'), value: 'server' },
        { text: this.$t('rate_resource_type.baremetal'), value: 'baremetal' },
        { text: this.$t('rate_resource_type.disk'), value: 'disk' },
        { text: this.$t('rate_resource_type.snapshot'), value: 'snapshot' },
        { text: this.$t('rate_resource_type.loadbalancer'), value: 'loadbalancer' },
        { text: this.$t('rate_resource_type.bucket'), value: 'bucket' },
        { text: this.$t('rate_resource_type.dbinstance'), value: 'dbinstance' },
        { text: this.$t('rate_resource_type.file_system'), value: 'file_system' },
        { text: this.$t('rate_resource_type.elasticcache'), value: 'elasticcache' },
        { text: this.$t('rate_resource_type.natgateway'), value: 'natgateway' },
      ],
      usageTypeOptions: [
        { text: this.$t('rate_usage_type.capacity'), value: 'capacity' },
        { text: this.$t('rate_usage_type.instance'), value: 'instance' },
        { text: this.$t('rate_usage_type.volume'), value: 'volume' },
        { text: this.$t('rate_usage_type.bandwidth'), value: 'bandwidth' },
        { text: this.$t('rate_usage_type.attached_device'), value: 'attached_device' },
        { text: this.$t('rate_usage_type.backup_instance'), value: 'backup_instance' },
      ],
      brandParams: {
        query_type: 'platform_brand',
        scope: this.$store.getters.scope,
      },
    }
  },
  created () {
    this.fetchData()
  },
  methods: {
    getBillResourceTypeLabel,
    brandMapper (list) {
      return [{ id: 'all', item_id: 'all', item_name: this.$t('bill.text_259') }, ...list]
    },
    getBrandName (item) {
      const { item_name = '' } = item
      const HYPERVISORS_MAP = arrayToObj(HYPERVISORS, 'brand')
      return HYPERVISORS_MAP[item_name]?.label || item_name
    },
    specKeyValidator (rule, val, callback) {
      if (!val) {
        callback(new Error(this.$t('common.tips.input', [this.$t('bill.rate.spec_name')])))
      }
      const { field = '' } = rule
      const index = field.split('.')[1]
      let isSame = false
      this.form.spec.map((item, idx) => {
        if (idx !== parseInt(index) && item.key === val) {
          isSame = true
        }
      })
      if (isSame) {
        callback(new Error(this.$t('bill.rate.spec_key_not_repeat')))
      }
      callback()
    },
    fetchData () {
      this.manager = new this.$Manager('rates', 'v1')
      this.manager.get({ id: this.params.data[0].id })
        .then((res) => {
          this.$nextTick(() => {
            const initSpecValue = []
            const { spec = {} } = res.data
            const keys = Object.keys(spec)
            keys.map(key => {
              initSpecValue.push({ key, value: spec[key] })
            })
            this.form = {
              resource_type: res.data.resource_type,
              usage_type: res.data.usage_type,
              brand: res.data.brand || 'all',
              model: res.data.model,
              spec: initSpecValue,
              no_bill: res.data.no_bill,
            }
          })
        })
    },
    doEdit (data) {
      return new this.$Manager('rates', 'v1').update({
        id: this.params.data[0].id,
        data,
      })
    },
    async handleConfirm () {
      this.loading = true
      try {
        await validateModelForm(this.$refs.form)
        const { resource_type, usage_type, brand, model, spec: specList, no_bill } = this.form
        const spec = {}
        specList.map(item => {
          spec[item.key] = item.value
        })
        const params = {
          resource_type,
          usage_type,
          brand: brand === 'all' ? '' : brand || '',
          model,
          spec: spec,
          rate_set_id: this.params.rateSetId,
          no_bill,
        }
        await this.doEdit(params)
        this.loading = false
        this.cancelDialog()
        this.params.refresh()
      } catch (error) {
        this.loading = false
        throw error
      }
    },
  },
}
</script>
